/**
 * Botón de configuración (engranaje) — abre el sidebar de Configuración
 * con InitialScreen variant='sidebar'. Hermano visual de InfoButton, reusa
 * sus estilos base via la clase .info-button.
 */

import './InfoButton.css'; // reusa .info-button para el estilo base
import './SettingsButton.css';

interface SettingsButtonProps {
  onClick: () => void;
  isOpen?: boolean;
  /** Modo profesor (aide-prof): etiqueta en francés. Por defecto español. */
  aideProf?: boolean;
}

export function SettingsButton({ onClick, isOpen = false, aideProf = false }: SettingsButtonProps) {
  const label = aideProf ? 'Configuration' : 'Configuración';
  return (
    <button
      type="button"
      className={`info-button settings-button ${isOpen ? 'hidden' : ''}`}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="settings-icon"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    </button>
  );
}
